import math from 'common/math';
import Vue from 'vue';

Vue.filter('math', (value, type, secondValue) => {
  const valueNumber = Number(value);
  const secondNumber = Number(secondValue);

  if (Number.isNaN(valueNumber) || Number.isNaN(secondNumber)) return 0;

  return math[type](valueNumber, secondNumber);
});
